/**
 * 전역 변수 설정 용도로 활용 중
 * 
 * BASE_URL: API 서버 요청 위치
 */
export const BASE_URL = '/api/';
// export const BASE_URL = ''
export const PERMISSIONS = {
    SUPER_ADMIN: '01',
    ADMIN: '11',
    USER: '21'
};
export const config = {
    // basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
    // like '/berry-material-react/react/default'
    basename: '',
    defaultPath: '/',
    fontFamily: `'NanumSquareNeo', sans-serif`,
    borderRadius: 4
};

// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;

// app base title
export const popupTitle = 'OneDealPay';
export const appTitle = 'OneDealPay';
export const appTitleKOR = '원딜페이';
export const popupTitleKOR = '원딜페이';